import React, { useEffect, useState } from "react";
import {
    Box, makeStyles, Dialog, IconButton, CircularProgress,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { OPTIONS_DEVICES } from './helpers'
//Componentes
import { Alert } from '@material-ui/lab';
import PhaseControl from "./PhaseControl";
// import DeleteControl from "./DeleteControl";
import ReleControl from "./ReleControl";
import AlarmsControl from "./AlarmsControl";
//Services
import { getControlSetting } from '../../services/meters';
import { connectWebSocket } from '../../helpers/socketFunctions';
//helpers 
import { removeLastDashNumber, getLastPartAfterDash, mergeMonoPhaseAlarmSmartNewVersion, mergeTrifasicoPhaseAlarmSmartNewVersion, } from "./helpers";

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: '180px',
        margin: "auto",
        padding: theme.spacing(1, 1, 1, 1),
        gap: theme.spacing(1),
        width: "100%",
        // -webkit-backdrop-filter: blur(10px);
        backdropFilter: "blur(10px)",
        "@media (max-width: 920px)": {
            flexWrap: "wrap",
            justifyContent: "center",
            padding: theme.spacing(0),
        }
    },
    box: {
        width: "50%",
        "@media (max-width: 920px)": {
            width: "80%",
        }
    },
    alerts: {
        fontSize: "large",
        width: '100%',
        zIndex: "2",
        margin: theme.spacing(1, 0, 0, 0),
    },
}));

export default function ControlModal({ openModal, setOpenModal, data, selectedNode, selectedMeterAux }) {
    const classes = useStyles();
    const [stateData, setSatateData] = useState({})
    const [showError, setShowError] = useState(true)
    //Loading control.
    const [loading, setLoading] = useState(false)
    //Loading de la caja interna espera todas las consultas de los controles.
    const [loadingInbox, setLoadingInbox] = useState(true)
    //Estados alert.
    const [alertState, setAlertState] = useState({
        close: false,
        type: "info",
        msg: "mensaje"
    })
    const dataAux = {
        plan: data?.product,
        id: data?.medidor_id
    }
    //estado del mensaje del socket
    const [stateHelper, setStateHelper] = useState({
        status: false,
        result: 'error'
    });

    useEffect(() => {
        const GetInfo = async () => {
            setAlertState({
                ...alertState,
                type: '',
                close: false,
            })
            //Si el modal esta abierto hace las consultas.
            if (openModal) {
                if (data?.product === OPTIONS_DEVICES.SMART || data?.product === OPTIONS_DEVICES.HOME) {
                    getAllControls()
                }
                else {
                    setOpenModal(true)
                    setShowError(true)
                    let objAux = {
                        selectedNode: selectedNode,
                        extraData: data
                    }
                    getSocketControls(objAux)
                    setSatateData(objAux)
                }
            }
        }
        GetInfo()
        return (() => {
            setLoadingInbox(true)
        })
        // eslint-disable-next-line 
    }, [openModal])

    //Respuesta socket
    useEffect(() => {
        if (stateHelper.status === "completed") {
            let res = {}
            //Verifico si es trifasico        
            if (selectedNode?.es_trifasico) {
                console.log('TRIFASICO')
                res = mergeTrifasicoPhaseAlarmSmartNewVersion(stateHelper?.data)
            }
            //Verifico si es Monofasico
            else {
                console.log('MONOFASICO')
                res = mergeMonoPhaseAlarmSmartNewVersion(stateHelper?.data)
            }

            if (stateHelper?.data) {
                setSatateData(res)
            }
            setLoading(false)
            setLoadingInbox(false)
            return
        }
        if (stateHelper.status === "failed" || stateHelper.status === "error") {
            setAlertState({
                close: true,
                msg: stateHelper?.observation ? stateHelper?.observation : stateHelper?.message,
                type: "error"
            })
            // setLoading(false)
            setLoadingInbox(false)
            return
        }
        if (stateHelper.status === "disconnected") {
            // setLoading(false)
            setLoadingInbox(false)
        }
    }, [stateHelper])

    const getSocketControls = (stateData) => {
        // Envio mensaje por socket para los modelos nuevos es dinamico
        const message = {
            value: {
                mac: removeLastDashNumber(stateData?.selectedNode?.realtime?.llave, stateData),
                time: null,
                device_type: stateData?.selectedNode?.realtime?.producto,
                action: "GET_ALARMS",
                extra_info: { id: getLastPartAfterDash(stateData?.selectedNode?.realtime?.llave, stateData) }
            },
            type: "ALARM_MANAGER",
        };
        connectWebSocket(message, setStateHelper);

    }

    const getAllControls = async () => {
        let msg = "Ocurrio un error inesperado"
        let type = "error"
        try {
            setOpenModal(true)
            setShowError(true)
            setLoadingInbox(true)
            let key = 'UMBRALES_GET&key=TIMER_GET&key=RELAY_STATUS'
            let res = await getControlSetting(key, dataAux?.id)
            let UMBRALES_GET = res?.data.find(objeto => objeto.key === 'UMBRALES_GET');
            let TIMER_GET = res?.data.find(objeto => objeto.key === 'TIMER_GET');
            let RELAY_STATUS = res?.data.find(objeto => objeto.key === 'RELAY_STATUS');
            setSatateData(
                {
                    UMBRALES_GET,
                    TIMER_GET,
                    RELAY_STATUS
                }
            )
        }
        catch (error) {
            if (error?.response?.data) {
                type = "error"
                msg = error?.response?.data.MSJ
            }
            // setShowError(false)
            setAlertState({
                close: true,
                msg: msg,
                type: type
            })
        }
        setLoadingInbox(false)
    }

    const validateCloseModal = () => {
        if (alertState.type === 'error') {
            setOpenModal(false);
        }
    }

    return (
        <>
            {/* Container loading */}


            {/* Container Main */}
            <Dialog
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="modal_phase_control"
                disableScrollLock
                fullWidth
                maxWidth='sm'
            >
                {alertState.close &&

                    <Alert
                        className={classes.alerts}
                        severity={alertState.type}
                        action={
                            <IconButton
                                aria-label='close'
                                size='small'
                                onClick={() => {
                                    setAlertState(prev => ({
                                        ...prev,
                                        close: false,
                                    }));
                                    validateCloseModal()
                                }}
                            >
                                <CloseIcon fontSize='inherit' />
                            </IconButton>
                        }
                    >
                        {alertState.msg}
                    </Alert>

                }
                {showError &&
                    <Box display="flex" className={classes.root}>

                        {
                            loadingInbox ?
                                <Box display="flex" justifyContent="center" alignItems={'center'} width="100%" m={4}>
                                    {
                                        alertState?.type !== 'error' &&
                                        <CircularProgress />
                                    }
                                </Box>
                                :
                                <>
                                    {
                                        alertState?.type !== 'error' &&
                                        <>
                                            {/* Caja izquierda */}
                                            <Box className={classes.box}>
                                                <AlarmsControl
                                                    selectedNode={selectedNode}
                                                    setLoadingInbox={setLoadingInbox}
                                                    setStateHelper={setStateHelper}
                                                    stateData={stateData}
                                                    setSatateData={setSatateData}
                                                    options={dataAux}
                                                    setLoading={setLoading}
                                                    setAlertState={setAlertState}
                                                />
                                            </Box>

                                            {/* Caja derecha */}
                                            <Box
                                                className={classes.box}>
                                                {/* el rele solo aparece en la opcion de powermeter home */}
                                                {dataAux.plan === OPTIONS_DEVICES.SMART &&
                                                    <ReleControl
                                                        stateData={stateData}
                                                        options={dataAux}
                                                        setLoading={setLoading}
                                                        setAlertState={setAlertState}
                                                    />
                                                }
                                                <PhaseControl
                                                    setStateHelper={setStateHelper}
                                                    selectedNode={selectedNode}
                                                    options={dataAux}
                                                    dataPhases={data?.phases}
                                                    setLoadingInbox={setLoadingInbox}
                                                    setLoading={setLoading}
                                                    setAlertState={setAlertState}
                                                    selectedMeterAux={selectedMeterAux}
                                                />
                                                {/* {
                                            validateShowComponent() &&
                                            <DeleteControl
                                                options={dataAux}
                                                setLoading={setLoading}
                                                setAlertState={setAlertState}
                                            />
                                        } */}
                                            </Box>
                                        </>
                                    }

                                </>

                        }
                    </Box>}
            </Dialog >
        </>
    )
}